import { getConfig } from '@/configs/config-accessor';
import { handleGetCollection } from '@/constants/db-collection.constants';
import ApiService from './ApiService';

// Get the API prefix from the config accessor
const getApiPrefix = () => getConfig().newApiPrefix;

export interface INotification extends ICommonFields {
  _id: string;
  type: 'success' | 'error' | 'info';
  authId: string;
  isRead: boolean;
  title: string;
  body: string;
  data: Record<string, unknown>;
}

export type GetNotificationsByAuthId_Params = Pick<INotification, 'authId'>;
export type GetNotificationsByAuthId_Limit = number;
export type GetNotificationsByAuthId_Response = IResponse<INotification[] | null>;
export const getNotificationsByAuthId = async (params: GetNotificationsByAuthId_Params, limit?: GetNotificationsByAuthId_Limit) => {
  const newApiPrefix = getApiPrefix();
  return ApiService.fetchData<GetNotificationsByAuthId_Response, DynamicGet_Body>({ 
    url: `${newApiPrefix}/dynamicmongodb/get`, 
    method: 'post', 
    data: { 
      collection: handleGetCollection('notification'), 
      filter: { authId: params.authId }, 
      limit: limit 
    } 
  });
};

export type UpdateNotification_Params = { _id: string };
export type UpdateNotification_Body = Partial<Omit<INotification, '_id'>>;
export type UpdateNotification_Response = IResponse<INotification | null>;
export const updateNotification = async (params: UpdateNotification_Params, body: UpdateNotification_Body) => {
  const newApiPrefix = getApiPrefix();
  return ApiService.fetchData<UpdateNotification_Response, DynamicUpdate_Body<UpdateNotification_Body>>({ 
    url: `${newApiPrefix}/dynamic/update`, 
    method: 'patch', 
    data: { 
      collection: handleGetCollection('notification'), 
      filter: { _id: params._id }, 
      data: body 
    } 
  });
};
